import { TextField } from "@mui/material";
import React from "react";

const SharedTextField = (props) => {
  return (
    <>
      <TextField
        {...props}
        sx={{
          ...props?.sx,
          width: "100%",
          padding: "0px !important",
          height: "36px",
          "& .MuiInputBase-input": {
            fontSize: "14px",
            padding: "0px",
          },
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#FFF !important",
            alignItems: props?.height && "flex-start",
            height: "36px",
            padding: "8px 12px !important",
            borderRadius: "8px",
            "& fieldset": {
              borderRadius: "8px",
              padding: "0px",
              border: "1px solid #D8D8D8",
            },
            "&:hover fieldset": {
              border: "1px solid #AEAEAE",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid #512ACC",
            },
            "&.Mui-error fieldset": {
              borderColor: "#F75443",
            },
          },
        }}
      />
    </>
  );
};

export default SharedTextField;
